import { useCompany } from 'src/core/modules/app/hooks/useCompany';
import { useUser } from 'src/core/modules/app/hooks/useUser';

export const usePlasticCard = () => {
  const user = useUser();
  const company = useCompany();
  return user.data_by_company[company.id]?.plastic_card;
};
